import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { CustomSVG } from 'components';

interface IProps extends WithStyles<typeof styles> {
  onToggle: () => void;
}

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    imageContainer: {
      position: 'relative',
      borderRadius: 4,
      overflow: 'hidden',
      cursor: 'pointer',
      '&:hover': {
        '& $children': {
          filter: 'contrast(10%)',
        },
        '& $imageChange': {
          opacity: 1,
        },
      },
    },
    imageChange: {
      position: 'absolute',
      top: '50%',
      left: '20%',
      transform: 'translateY(-50%)',
      maxWidth: '60%',
      color: palette.common.white,
      opacity: 0,
      transition: 'opacity 250ms ease-in-out',
      textAlign: 'center',
    },
    cameraIcon: {
      marginBottom: spacing(1),
    },
    children: {
      transition: 'all 250ms ease-in-out',
    },
  });

const ImageChange: FC<IProps> = ({ classes, children, onToggle }) => (
  <div className={classes.imageContainer} onClick={onToggle}>
    <div className={classes.children}>{children}</div>
    <div className={classes.imageChange}>
      <CustomSVG name="camera" size={50} className={classes.cameraIcon} />
      <Typography color="inherit" variant="subtitle2">
        <Trans i18nKey="groups:imageChange" />
      </Typography>
    </div>
  </div>
);

export default withStyles(styles)(ImageChange);
